export default __webpack_public_path__ + "static/iso_9001-37b697316a83dfae427b124b5e2a9b84.webp";